import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AspHomeService } from 'app/main/auto-spare-parts/asp-home/asp-home.service';
import { AspLoadingService } from 'app/main/auto-spare-parts/asp-loading/asp-loading.service';


@Component({
  selector: 'app-asp-reg-dec-popup',
  templateUrl: './asp-reg-dec-popup.component.html',
  styleUrls: ['./asp-reg-dec-popup.component.scss']
})
export class AspRegDecPopupComponent implements OnInit {

  @Output() close = new EventEmitter<void>();

  vehicleForm!: FormGroup;
  loading: boolean = false;
  submitted = false;
  vehicleInfo = false;
  vehicleData: any;
  isMobile = window.innerWidth < 768;
  selectedProductKey: any;

  constructor(
    private _formBuilder: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private homeService: AspHomeService,
    private aspLoadingService: AspLoadingService,
  ) {}

  ngOnInit(): void {
    sessionStorage.removeItem('wishlist');
    sessionStorage.removeItem("suggestionMap");
    localStorage.removeItem('filterParams');
    localStorage.removeItem('selectedCategory');
    localStorage.removeItem('selectedBrands');
    localStorage.removeItem('selectedRequestStatus');
    localStorage.removeItem('selectedRequestTime');
    localStorage.removeItem('isDynamicPopup'); 
    // localStorage.removeItem('registrationNumber');
    localStorage.removeItem('searchItems');
    localStorage.removeItem('selectedKits');
    localStorage.removeItem("kitFlow");
    this.vehicleForm = this._formBuilder.group({
      regNo: ['', [Validators.required, Validators.maxLength(13)]]
    });

    // Format registration number automatically
    this.vehicleForm.get('regNo')?.valueChanges.subscribe(value => {
      if (value) {
        const formattedValue = this.formatRegNo(value);
        this.vehicleForm.get('regNo')?.setValue(formattedValue, { emitEvent: false });
      }
    });

    // Restore vehicle data if already available
    this.vehicleData = JSON.parse(localStorage.getItem("vehicleData") || 'null');

    if (this.vehicleData) {
      this.vehicleInfo = true;
    }
  }

  get f() {
    return this.vehicleForm.controls;
  }

  closePopup(): void {
    this.close.emit();
  }

  formatRegNo(value: string): string {
    return value.toUpperCase().replace(/[^A-Z0-9 ]/g, '');
  }

  onSubmit() {
    this.submitted = true;

    if (this.vehicleForm.invalid) {
      return;
    }

    this.aspLoadingService.show();

    const regNumber = this.f.regNo.value.replace(/\s/g, "");

    this.homeService.regDecode(regNumber).subscribe(
      (res: any) => {

        if (res.code === 200) {

          this.aspLoadingService.hide();

          // If variant not available → go to variant selection page
          if (!res.data?.variantKey && !res.data?.variant) {

            localStorage.setItem("selectedMake", res.data?.make);
            localStorage.setItem("selectedModel", res.data?.model);
            localStorage.setItem("selectedYear", res.data?.year);
            localStorage.setItem("rowKey", res.data?.rowKey);
            localStorage.setItem("variant", res.data?.variant);
            localStorage.setItem("imageUrlPath", res.data?.imageUrlPath);
            localStorage.setItem("registrationNumber", res.data?.registrationNumber);
            localStorage.setItem("vin", res.data?.vin);
            // console.log("vehicleData.variant",res.data?.variant);
            // console.log("vehicleData.variantKey",res.data?.variantKey)
            if(res.data?.variant =='' ||res.data?.variant ==null ||res.data?.variantKey == null || res.data?.variantKey == '')
              {
              localStorage.setItem("kitFlow", "1")
              this.router.navigate(['variant']);
            }

            this.router.navigate(['variant']); // adjust route if needed
            return;
          }

          // ✅ Vehicle found properly
          this.vehicleInfo = true;
          this.vehicleData = res.data;

          localStorage.setItem("vehicleData", JSON.stringify(this.vehicleData));
          localStorage.setItem(
            "registrationNumber",
            this.vehicleData.registrationNumber.replace(/"/g, '')
          );

        } else {
          this.aspLoadingService.hide();
          this.toastr.error(res?.data?.description || 'Something went wrong', 'Error');
        }
      },
      error => {
        this.aspLoadingService.hide();
        this.toastr.error('Registration decode failed', 'Error');
      }
    );
  }
   changeCar() {
    localStorage.removeItem('vehicleData');
    localStorage.removeItem('registrationNumber');
    localStorage.removeItem("isVariantFlow")
    localStorage.removeItem('vin');
    localStorage.removeItem("selectedSparesList");
    localStorage.removeItem("selectedSparesList");
    // this.ngOnInit();
    this.vehicleInfo = false;
  this.vehicleData = null;
  this.vehicleForm.reset();
  this.submitted = false;
  }

  confirmCar() {

    let vehicleData = JSON.parse(localStorage.getItem('vehicleData') || 'null');
    if (!vehicleData) return;

    localStorage.setItem('selectedMake', vehicleData.make);
    localStorage.setItem('selectedModel', vehicleData.model);
    localStorage.setItem('rowKey', vehicleData.rowKey);
    localStorage.setItem('selectedYear', vehicleData.year);
    localStorage.setItem('selectedFuel', vehicleData.fuel);
    localStorage.setItem('fuelType', vehicleData.fuel);
    localStorage.setItem('variant', vehicleData.variant);
    localStorage.setItem('variantKey', vehicleData.variantKey);
    // console.log("vehicleData.variant",vehicleData.variant);
    // console.log("vehicleData.variantKey",vehicleData.variantKey)
    // navigate using your existing structure
    this.router.navigate(['/product-details', 'kit', 'decode']);
  }


  sparesListNew(name, type, imageUrl = '', key = '') {
    const isFindMyCar = localStorage.getItem("isFindMyCar");
    
    if (isFindMyCar !== "1") {
      localStorage.setItem(
        "selectedSparesList",
        JSON.stringify({ name, type, imageUrl, key })
      );
    }

    localStorage.setItem("isDynamicPopup", "true");
    this.router.navigate(['spare-parts-list']);
  }


  goToProduct(product: any) {

    if (!localStorage.getItem('vehicleData')) {

      localStorage.setItem('pendingKitKey', product.key);

      return;
    }

    this.router.navigate(['/product-details', 'kit', product.key]);
  }
  goToMake = () => {
    localStorage.setItem("kitFlow", "1");
    this.router.navigate(['make']);
  }
goToVariant = () => {
    // this.clearSelectedBrandCat();
    // localStorage.setItem('isVariantFlow', '1');
    localStorage.setItem("kitFlow", "1")
    this.router.navigate(['variant']);
  }
}
